import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { useSearchAlertResponders } from '../../../hooks';
export function useAlertRespondersTable(data) {
    return useDataTableUsingState({
        useDataProvider: (request) => {
            const responders = useSearchAlertResponders(data.id, request);
            let idCounter = 0;
            return {
                data: responders.data
                    ? {
                        rows: responders.data.items.map((responder) => { var _a; return (Object.assign(Object.assign({}, responder), { id: (_a = responder.externalId) !== null && _a !== void 0 ? _a : '_' + ++idCounter })); }),
                        filteredRowCount: responders.data.totalCount,
                    }
                    : undefined,
                error: responders.error,
                isLoading: responders.isLoading,
                reload: responders.mutate,
            };
        },
        defaultSortColumnKey: '-',
        rowSelectionEnabled: true,
    });
}
